import { render, staticRenderFns } from "./gaming.vue?vue&type=template&id=b5554954&scoped=true"
import script from "./gaming.vue?vue&type=script&lang=js"
export * from "./gaming.vue?vue&type=script&lang=js"
import style0 from "./gaming.vue?vue&type=style&index=0&id=b5554954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5554954",
  null
  
)

export default component.exports